import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ProductResponse } from 'src/app/models/product.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { ProductConversionService } from 'src/app/services/product-conversion.service';
import { ProductService } from 'src/app/services/product.service';

@Component({
  selector: 'app-product-conversion',
  templateUrl: './product-conversion.component.html',
  styleUrls: ['./product-conversion.component.scss']
})
export class ProductConversionComponent implements OnInit {

  products = [];
  productsConversion = [];
  targetProductsConversion = [];
  filterProductsEntry: ProductResponse[] = [];
  filterProductsOutput: ProductResponse[] = [];
  timeoutEntry = null;
  timeoutOutput = null;
  productSelected: any = null;
  productSelectedId: number = null;
  filterWord: string = '';
  timeout = null;

  pagination = {
    total: [],
    filter: [],
    pageSize: 5,
    startElement: 0,
    lastElement: 0,
    pageIndex: 0
  }
  inputs = {
    productEntry: {
      value: null,
      verified: false,
      required: false,
      message: 'Campo requerido',
      class: "fa-list",
      color: '',
      tooltip: '',
      data: { id: null }
    },
    productOutput: {
      value: null,
      verified: false,
      required: false,
      message: 'Campo requerido',
      class: "fa-list",
      color: '',
      tooltip: '',
      data: { id: null }
    },
  };
  factor = 0;
  editingFactor: { [key: number]: boolean } = {};
  deleting: { [key: number]: boolean } = {};
  deletingTarget: { [key: number]: boolean } = {};
  editingFactorId: { [key: number]: boolean } = {};
  editingFactorValue: number | null = null;
  savingFactor = false;

  constructor(private productConversionService: ProductConversionService,
    private productService: ProductService,
    private toastService: ToastrService) { }

  ngOnInit(): void {
    this.getProducts("", this.inputs.productEntry, 'entry');
    this.getProducts("", this.inputs.productOutput, 'output');
    this.getAllProductsConversion();
  }

  changeInput(input, value, verified, required, classIcon, data) {
    input.value = (value !== undefined && value !== null) ? value : input.value;
    input.verified = (verified !== undefined && verified !== null) ? verified : input.verified;
    input.required = (required !== undefined && required !== null) ? required : input.required;
    input.class = (classIcon) ? classIcon : input.class;
    input.data = (data) ? data : input.data;
  }

  resetPagination() {
    this.pagination.filter = this.pagination.total.slice(0, this.pagination.pageSize);
    this.pagination.pageIndex = 0;
    this.pagination.lastElement = this.pagination.filter.length;
    this.pagination.startElement = 0;
  }

  onInputChange(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    this.filterWord = value;
    this.searching();
  }

  searching() {
    this.pagination.total = this.productsConversion.filter((item) => {
      const filter = this.filterWord.toLowerCase();

      return (
        item.code.toLowerCase().includes(filter) ||
        item.name.toLowerCase().includes(filter) ||
        (this.productSelectedId && this.productSelectedId == item.id)
      );
    });

    this.pagination.pageIndex = 0;
    this.pagination.startElement = 0;
    this.pagination.filter = this.pagination.total.slice(0, this.pagination.pageSize);
    this.pagination.lastElement = this.pagination.filter.length;
  }

  getProducts(clue: string, inputRef: any, target: 'entry' | 'output') {
    this.productService.getProducts(clue).subscribe({
      next: (response: ResponseObject) => {
        const list: ProductResponse[] = response.data || [];
        this.products = list;

        if (target === 'entry') this.filterProductsEntry = list;
        else this.filterProductsOutput = list;

        if (list.length === 0) {
          this.changeInput(inputRef, null, false, null, 'fa-xmark', null);
        } else if (list.length === 1) {
          this.changeInput(inputRef, list[0].name, true, null, 'fa-circle-check', list[0]);
        } else {
          this.changeInput(inputRef, clue, false, null, 'fa-list', null);
        }
      }
    });
  }

  writeProductEntry(inputEvent: any) {
    const inputValue = inputEvent.target.value;   // <- IGUAL QUE TU EJEMPLO
    clearTimeout(this.timeoutEntry);
    this.inputs.productEntry.class = "typing";
    this.timeoutEntry = setTimeout(() => {
      this.getProducts(inputValue, this.inputs.productEntry, 'entry');
    }, 500);
  }

  writeProductOutput(inputEvent: any) {
    const inputValue = inputEvent.target.value;
    clearTimeout(this.timeoutOutput);
    this.inputs.productOutput.class = "typing";
    this.timeoutOutput = setTimeout(() => {
      this.getProducts(inputValue, this.inputs.productOutput, 'output');
    }, 500);
  }

  checkProductEntry(product: any) {
    this.changeInput(
      this.inputs.productEntry,
      product.code + " - " + product.name,
      true,
      null,
      "fa-circle-check",
      product
    );
  }

  checkProductOutput(product: any) {
    this.changeInput(
      this.inputs.productOutput,
      product.code + " - " + product.name,
      true,
      null,
      "fa-circle-check",
      product
    );
  }

  reset() {
    this.inputs.productEntry.value = null;
    this.inputs.productEntry.verified = false;
    this.inputs.productEntry.class = "fa-list";
    this.inputs.productEntry.data = { id: null };

    this.inputs.productOutput.value = null;
    this.inputs.productOutput.verified = false;
    this.inputs.productOutput.class = "fa-list";
    this.inputs.productOutput.data = { id: null };

    this.factor = 0;

    this.filterProductsEntry = [];
    this.filterProductsOutput = [];
  }

  calculateResult(): number {
    if (!this.factor) { return 0; }

    const quantity = 1;;
    return quantity * this.factor;
  }

  getAllProductsConversion() {
    this.productConversionService.getAllProductsConversion().subscribe({
      next: (response: any) => {
        this.productsConversion = response.data ?? [];
        this.searching();
      },
      error: (err: any) => { }
    });
  }

  saveConfig() {
    if (!this.inputs.productEntry.data.id || !this.inputs.productOutput.data.id || !this.factor) {
      this.toastService.warning("Debe completar todos los campos para agregar una configuración.");
      return;
    }

    const payload = {
      productId: this.inputs.productEntry.data.id,
      targetProductId: this.inputs.productOutput.data.id,
      factor: this.factor
    };

    this.productConversionService.postCreateProductConversion(payload).subscribe({
      next: () => {
        this.toastService.success(
          'Configuración de producto guardado correctamente',
          'Éxito'
        );
        this.reset();
        this.getAllProductsConversion();
        this.getTargetProducts();
      },
      error: (err) => {
        this.toastService.error(
          err?.error?.data.description || 'No se pudo guardar la configuración',
          'Error'
        );
        console.error(err);
      }
    });
  }

  setProductConversion(item: any) {
    if (item.id == this.productSelectedId) {
      this.productSelectedId = null;
      this.productSelected = null;
      this.targetProductsConversion = [];
      return;
    }
    this.productSelectedId = item.id;
    this.productSelected = item;
    this.getTargetProducts();
  }

  getTargetProducts() {
    if (!this.productSelectedId) {
      this.targetProductsConversion = [];
      return;
    }

    this.productConversionService.getAllTargetProductByProductId(this.productSelectedId).subscribe({
      next: (response: ResponseObject) => {
        this.targetProductsConversion = response.data ?? [];
      },
      error: (err: any) => {
        this.toastService.error(
          err?.error?.data.description || 'No se pudo obtener la configuración del producto.',
          'Error'
        );
        console.error(err);
      }
    });
  }

  deleteAllProductConversion(id: number) {
    this.deleting[id] = true;
    this.productConversionService.deleteAllByProductId(id).subscribe({
        next: () => {
            this.toastService.success(
                'Configuracion de productos eliminado correctamente',
                'Éxito'
            );
            this.reset();
            this.productSelectedId = null;
            this.productSelected = null;
            this.getAllProductsConversion();
            this.getTargetProducts();
            this.deleting[id] = false;
        },
        error: (err) => {
            this.toastService.error(
                err?.error?.data.description || 'No se pudo eliminar las configuraciones',
                'Error'
            );
            console.error(err);
            this.deleting[id] = false;
        }
    });
  }

  deleteProductConversionById(id: number) {
    this.deletingTarget[id] = true;
    this.productConversionService.deleteByProductConversionId(id).subscribe({
        next: () => {
            this.toastService.success(
                'Configuracion de productos eliminado correctamente',
                'Éxito'
            );
            this.reset();
            this.getTargetProducts();
            this.getAllProductsConversion();
            this.deletingTarget[id] = false;
        },
        error: (err) => {
            this.toastService.error(
                err?.error?.data.description || 'No se pudo eliminar las configuraciones',
                'Error'
            );
            console.error(err);
            this.deletingTarget[id] = false;
        }
    });
  }

  startEditingFactor(item: any): void {
    this.editingFactorId = {};
    this.editingFactorId[item.id] = true;
    this.editingFactorValue = item.factor;
  }

  cancelEditingFactor(item: any): void {
    this.editingFactorId[item.id] = false;
    this.editingFactorValue = null;
  }

  saveFactor(item: any): void {
    if (this.editingFactorValue === null || this.editingFactorValue < 0) {
      return;
    }

    this.savingFactor = true;

    // Tu llamada al backend
    this.productConversionService.updateFactorProductConversionId(
      item.productConversion.id,
      {factor: this.editingFactorValue}
    ).subscribe({
      next: (res: any) => {

        // Actualizamos el objeto solamente cuando el backend respondió OK
        item.factor = this.editingFactorValue;
        item.productConversion.factor = res.data.factor;


        this.editingFactorId[item.productConversion.id] = false;
        this.editingFactorValue = null;
        this.savingFactor = false;
        this.toastService.success("Factor actualizado correctamente.")
      },
      error: (err: any) => {
        this.savingFactor = false;
        this.editingFactorId[item.productConversion.id] = false;
        this.toastService.error(
          err?.error?.data.description || 'No se pudo guardar el factor requerido.',
          'Error'
        );
      }
    });
  }
}
